"use client";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { getActionsCost, processFileAction, processFileActionAPI, TFileActions } from "./actions";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Link from "next/link";
import Image from "next/image";
import { useKindeBrowserClient } from "@kinde-oss/kinde-auth-nextjs";
import LoginRedirect from "@/components/LoginRedirect";
import CartaTokens from '@/../public/images/tokens_sm.png';
import AdSterraNativeBanner from "@/components/adsterra-ui/adsterra-native-banner";
import AdSterraIFrameBannerAuto from "@/components/adsterra-ui/adsterra-ifram-auto";
import AdSterra320x50 from "@/components/adsterra-ui/adsterra_320x50";

// const actions = [
//   ['read', 2],
//   ['explain', 4],
//   ['analyze', 5],
//   ['brief', 3]
// ]

function FileAnalyzerWrapped() {
  const [file, setFile] = useState<File | null>(null);
  const [mode, setMode] = useState<'read' | 'explain' | 'analyze' | 'brief'>('explain');
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, isLoading, isAuthenticated } = useKindeBrowserClient();
  const [ actions, setActions ] = useState<TFileActions>([]);

  useEffect(() => {
    async function getActions () {
      let a = await getActionsCost();
      console.log(a.data);
      setActions(a.data);
    }
    getActions();

  }, []);

  const handleSubmit = async () => {
    if (!file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("mode", mode);
    
    const res = await processFileActionAPI(formData);

    // force user tokens balance component to refresh
		window.dispatchEvent(new Event('tokens-deducted'));
    
    setOutput(res!);
    setLoading(false);
  };

  return (
    <>
      <div className="space-y-8 max-w-7xl mx-auto">
        <div className='text-lg'>
          <Link className='underline' href={"/"}>Home</Link>
          <span className='pl-2 pr-2'>{">"}</span>
          <Link className='underline' href={"/dashboard"}>Dashbord</Link>
          <span className='pl-2 pr-2'>{"> File Analyzer"}</span>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100">
          File Reader and Analyzer
        </h1>
        <div className="text-gray-600 dark:text-gray-400">
          Got a hand written text you can't read?<br />
          Got a contract you need summarized and briefed?<br />
          Got a report you need analyzed?<br />
          Give us an image, text, word document or PDF file and let us do the thinking.
        </div>
        
        <div className="grid grid-cols-1 gap-8">
          {/* Left: Controls */}
          <div className="space-y-6">
            <div className="p-2 bg-gray-100 rounded-3xl shadow-[inset_4px_4px_10px_rgba(0,0,0,0.05),inset_-4px_-4px_10px_white] border border-gray-200">
              <input 
                type="file" 
                onChange={(e) => setFile(e.target.files?.[0] || null)}
                className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>

            <div className="flex justify-between p-1 bg-gray-200 rounded-xl shadow-inner">
              {actions.map((m) => (
                <button
                  key={m[0]}
                  onClick={() => setMode(m[0] as 'read' | 'explain' | 'analyze' | 'brief')}
                  className={`flex-1 py-2 px-2 rounded-lg capitalize transition-all ${mode === m[0] ? 'bg-white shadow-md text-blue-600 font-bold' : 'text-gray-500'}`}
                >
                  <div className="flex flex-col lg:flex-row justify-center items-center gap-2">
                    <div>{m[0]}</div>
                    <div className="flex justify-center items-center text-sm">
                      <span>{"("}</span><Image src={CartaTokens} width={20} height={20} alt="Carta AI Tokens" />
                      <span className="ml-1">{m[1]} <span className="hidden md:inline">tokens</span></span><span>{")"}</span>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <AdSterra320x50 />

            <Button onClick={handleSubmit} disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white transition duration-200 h-12 text-lg capitalize">
              {loading ? "Processing..." : `Run ${mode}`}
            </Button>
          </div>

          {/* Right: Output */}
          <Card className="p-6 bg-white shadow-2xl border-none min-h-[400px] overflow-auto prose prose-sm max-w-none">
            {output ? 
              <article className="prose prose-slate max-w-none prose-headings:font-bold prose-li:marker:text-blue-500">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {output}
                  </ReactMarkdown>
              </article>
            : <div className="h-full flex flex-col items-center justify-center text-gray-400">
                <span className="text-5xl mb-4">🕵🏼</span>
                <p>
                  Results will appear here...
                </p>
                
                
              </div>}
          </Card>
        </div>
      </div>

      <AdSterraIFrameBannerAuto position="bottom" />

      {/* 2. THE OVERLAY (Only shows if not logged in) */}
      {(!isAuthenticated && !isLoading) && (
        <LoginRedirect message="to analyze this job description" />
      )}
    </>
  );
}

export default FileAnalyzerWrapped